/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SubscriberBillingHistoryEdition {
  amount?: number;
  attempt?: number;
  boletoCode?: string;
  boletoExpirateDate?: Date;
  boletoStatus?: string;
  boletoUrl?: string;
  dateCreated?: Date;
  dateExpired?: Date;
  dateUpdated?: Date;
  discount?: number;
  editionId?: number;
  installment?: number;
  notifiedCIO?: boolean;
  paymentId?: number;
  paymentIdentificationCode?: string;
  paymentIdentificationMessage?: string;
  paymentLogId?: number;
  paymentMethod?: number;
  previousBillingId?: number;
  recurrence?: number;
  refundValue?: number;
  shippingPrice?: number;
  subscriberBillingId?: number;
  subscriberBillingStatus?: number;
  subscriberControlId?: number;
  subscriberId?: number;
  subscriptionId?: number;
  theme?: string;
  title?: string;
}
